import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'distance'
})
export class DistancePipe implements PipeTransform {
    private static TEN_METER = 10;
    private static FIFTY_METER = 50;
    private static ONE_KILOMETER = 995;
    private static TEN_KILOMETER = 10000;
    private static TEXT_DESTINATION_REACHED = 'Sie haben Ihr Ziel erreicht';

    transform(value: number, ...args: any[]): any {
        /*if(!environment.production) {
            return value > 10 ? this.localize(value, true) : DistancePipe.TEXT_DESTINATION_REACHED;
        }*/

        if (value >= DistancePipe.TEN_KILOMETER) {
            return `${this.localize(Math.round(value / 1000))} km`;
        } else if (value >= DistancePipe.ONE_KILOMETER) {
            return `${this.localize(Math.round(value / 100) / 10, true)} km`;
        } else if (value >= DistancePipe.FIFTY_METER) {
            return `${this.localize(Math.round(value / 10) * 10)} m`;
        } else if (value >= DistancePipe.TEN_METER) {
            return `${this.localize(Math.round(value / 5) * 5)} m`;
        }

        return DistancePipe.TEXT_DESTINATION_REACHED;
    }

    localize(value: number, showFractionDigits: boolean = false) {
        return value.toLocaleString('de', showFractionDigits ? {minimumFractionDigits: 1, maximumFractionDigits: 1} : {});
    }

}
